module.exports = __webpack_public_path__ + "img/5.a1967681.jpg";